const ON_CHANGE_DEBOUNCE_TIMER = 300;
const MAX_FILTER_VALUES = 30;  // Limit URL parameters (7 sliders × 30 = 210 params)

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};
